import React from 'react';
import Hero from '../components/Hero';
import HeroFilm from '../components/HeroFilm';
import HowItWorks from '../components/HowItWorks';
import Equipment from '../components/Equipment';
import Programs from '../components/Programs';
import Crews from '../components/Crews';
import Watch from '../components/Watch';
import Pricing from '../components/Pricing';
import Download from '../components/Download';
import FAQ from '../components/FAQ';

/**
 * The home page, section by section. Its own module, without a stylesheet,
 * so a test can render exactly what a visitor to / reads
 * (src/__tests__/launch.test.js). Not lazy: it is the first paint.
 */
const HomePage = () => (
  <>
    <Hero />
    <HeroFilm />
    <HowItWorks />
    <Equipment />
    <Programs />
    <Crews />
    <Watch />
    <Pricing />
    <Download />
    <FAQ />
  </>
);

export default HomePage;
